import React from "react";
import "./App.css";

function Videos() {
  return (
    <div>
      {/* ? Header  */}
      <div className="container">
        <div className="row">
        <header className="header">
          <nav className="navbar navbar-expand-lg py-3 fixed-top">
            <div className="container">
              <div className="d-flex justify-content-center align-items-center">
                <a
                  className="nav-logo m-0 mx-0 me-lg-3 p-0 text-decoration-none me-md-3"
                  href="/home">
                  HipHop
                </a>
                <img
                  src="/images/svg/cd.svg"
                  alt="cd"
                  id="cd"
                  className="m-0 px-0 d-none d-lg-block d-md-block d-sm-block"
                />
              </div>

              <button
                className=" navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon rounded rounded-1 "></span>
              </button>

              <div className="collapse navbar-collapse me-lg-3" id="navbarNav">
                <ul className="nav-ul navbar-nav mx-auto me-0 pe-3 align-items-md-center align-items-center">
                  <li className="mt-md-4 mt-sm-3 mt-4 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/home">
                      Inicio
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/videos">
                      Video clips
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/disc">
                      Discografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/bio">
                      Biografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 mt-sm-3 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/eventos">
                      Eventos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
        </div>
      </div>

      {/* ? Contenido  */}
      <div className="container content-v h-100 w-75 my-5 py-5">
        <div className="title">
          <h1 className="text-center pt-4">
            Video Clips con mucho FLOW <br /> <span>Turkano</span>
          </h1>
        </div>

        <div className="content-videos content-videos_turkano">
          <div className="card card-1">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/YhJUCcSQUmA?si=_ghhtiAQ2v7mY8h_g"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen></iframe>
          </div>

          <div className="card card-2">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/p4tmTX1lgS4"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen></iframe>
          </div>

          <div className="card card-3">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/cl8UyAcv42s?si=qYat_Sg2y3dJ0qBL"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen></iframe>
          </div>

          <div className="card card-4">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/OsJEumhTbgA?si=8nln_4JFan-_BIVG"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen></iframe>
          </div>
        </div>
      </div>

      {/* ? Pie  */}
      <footer className="footer">
        <div className="container d-flex flex-column align-items-center p-3 pb-0">
          <h1 className="footer-title text-center">
            Escúchanos en <br /> <span className="">Plataformas</span>
          </h1>

          <div className="footer-imgs d-flex justify-content-around w-75 mt-4">
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/youtube-f-w.svg"
                alt="YouTube"
                width="170"
                title="YouTube"
                id="img-yt"
              />
            </a>
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/yt_music-f-w.svg"
                alt="YouTube Music"
                width="80"
                title="YouTube Music"
              />
            </a>
            <a
              href="https://open.spotify.com/intl-es/artist/4xU5vqImsU2aw0egTk7p68?si=HFFGGeUcR2i29alfqrSfUg"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/spotify-f-w.svg"
                alt="Spotify"
                width="80"
                title="Spotify"
              />
            </a>
            <a
              href="https://link.deezer.com/s/33gNTeFkFpklf7NWxT4D7"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/deezer-f-w.svg"
                alt="Deezer"
                width="80"
                title="Deezer"
              />
            </a>
          </div>

          <div className="comunication w-50 d-lg-flex justify-content-around align-items-center py-3 pb-5 d-grid col-1">
            <div className="footer-contact text-center">
              <h2>Contacto</h2>
              <p>19117records@gmail.com</p>
              <p>3146148505</p>
            </div>
          </div>
        </div>

        <div className="copy d-flex justify-content-between mx-3 fs-6">
          <p>2023, &copy; TURKANO</p>
          <p className="otto text-uppercase">&copy; OTTO | Carlos Arteaga</p>
        </div>
      </footer>
    </div>
  );
}

export default Videos;
